import intl from 'react-intl-universal'

// eslint-disable-next-line import/prefer-default-export
export const required = value => {
  if (value) {
    if (Array.isArray(value)) {
      return value.length > 0 ? undefined : intl.get('validation.required')
    }
    return value !== 0 || value.toString().trim() !== '' ? undefined : intl.get('validation.required')
  }

  return intl.get('validation.required')
}
